<div id="success-menu" style="float:right">
  <kendo-dropdownlist [data]="items" [(ngModel)]="display">
  </kendo-dropdownlist>
</div>
<h3>
  Flow Governance Center
</h3>

<div class="grid-wrapper success">
  @if (this.display == 'Tile' ) {
    <kendo-grid
      [kendoGridBinding]="groups"
      [pageable]="true"
      [pageSize]="60"
      [scrollable]="'virtual'"
      [rowHeight]="400"
      class="success tile"
      >
      <kendo-grid-column>
        <ng-template kendoGridCellTemplate let-group="dataItem">
          <div style="max-height:380px;">
            {{group.name}} ({{ group.flows.length }})
            <br/>
            <h2 style="display:inline">{{ group.tRuns}}</h2> runs,
            <h2 style="display:inline;" [style.color]="group.tFails > 0 ? 'red' : 'black'">{{group.tFails}}</h2> fails,
            <h2 style="display:inline" [style.color]="group.tEstimates > 5000 ? 'red' : 'black'">{{ group.tEstimates | number:'1.0-0' }}</h2> rate,
            <h2 style="display:inline">{{ group.tActions | number:'1.0-0' }}</h2> actions
            <br/>
            <kendo-tabstrip [keepTabContent]="false" tabPosition="bottom" style="width: 300px; min-height:320px; max-height: 320px;">
              <kendo-tabstrip-tab title="Info" [selected]="group.name != 'Unmanaged'">
                <ng-template kendoTabContent>
                  <div style="overflow-y: auto;">
                    <h4>Name</h4>
                    @if (group.solution) {
                      <div title="{{group.solution.solutionid}}">{{group.solution.friendlyname}} ({{group.solution.version}})</div>
                    }
                    <h4>Environments</h4>
                    <ul>
                      @for (env of group.envs; track env) {
                        <li>{{env | json}}</li>
                      }
                    </ul>
                    <h4>Support</h4>
                    <ul>
                      @if (group.favicon) {
                        <li><img src="{{group.favicon}}"></li>
                      }
                      @if (group.solution) {
                        <li>{{group.solution.publisherid.friendlyname}}</li>
                      }
                      @if (group.solution) {
                        <li>{{group.solution.publisherid.supportingwebsiteurl}}</li>
                      }
                      @if (group.solution) {
                        <li>{{group.solution.publisherid.emailaddress}}</li>
                      }
                      @if (group.solution) {
                        <li>{{group.solution.publisherid.address1_telephone1}}</li>
                      }
                    </ul>
                    @if (group.solution) {
                      <h4>Solution</h4>
                    }
                    @if (group.solution) {
                      <ul>
                        <li title="{{group.solution.solutionid}}">{{group.solution.friendlyname}} ({{group.solution.version}})</li>
                      </ul>
                    }
                    <h4>Modified</h4>
                    <div>{{group.modified}}</div>
                  </div>
                </ng-template>
              </kendo-tabstrip-tab>
              <kendo-tabstrip-tab title="Flows" [selected]="group.name == 'Unmanaged'">
                <ng-template kendoTabContent *loadOnDemand>
                  <div style="overflow-y: auto;">
                    <kendo-sortable
                      [kendoSortableBinding]="group.flows"
                      [itemStyle] = "{'border': '0px', 'opacity':'1', 'cursor': 'move'}"
                      [emptyItemStyle] = "{'height': '350px', 'border': '2px dashed black'}"
                      [activeItemStyle] = "{'border': '2px dashed black', 'opacity':'0.7'}"
                      zone="innerZone">
                      <ng-template let-item="item">
                        <app-success-line [item]="item"></app-success-line>
                      </ng-template>
                    </kendo-sortable>
                  </div>
                </ng-template>
              </kendo-tabstrip-tab>
              <kendo-tabstrip-tab title="Systems">
                <ng-template kendoTabContent *loadOnDemand>
                  <div style="overflow-y: auto;">
                    <h4>Owners</h4>  <button (click)="loadMore(group)">^</button>
                    <ul>
                      @for (owner of group.owners; track owner) {
                        <li>{{owner}}</li>
                      }
                    </ul>
                    <h4>Connections ({{group.connections.length}})</h4>
                    @for (connection of group.connections; track connection) {
                      <div title="{{ connection.connectionName || connection | json}}">
                        <img [src]='this.getSafeUrl(connection.iconUri)' style='width:20px; height:20px; vertical-align:middle;' />
                        {{connection.displayName}}
                      </div>
                    }
                    <h4>Classification</h4>
                  </div>
                </ng-template>
              </kendo-tabstrip-tab>
            </kendo-tabstrip>
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  }

  @if (this.display == 'Grid' ) {
    <kendo-grid
      [kendoGridBinding]="groups"
      [pageable]="true"
      [pageSize]="60"
      [sort]="state.sort"
      [sortable]="true"
      [scrollable]="'virtual'"
      class="success grid"
      #grid
      >
      <ng-template kendoGridToolbarTemplate>
        <button class='k-button' (click)="this.onDoPdf(pdf)">PDF</button>
      </ng-template>
      <kendo-grid-column field="name" title="Solution" [width]="120" class="cell">
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{dataItem.name}}
        </ng-template>
        <!-- <ng-template kendoGridFooterTemplate let-column="column">
        <span title='Total Flows'>{{this.flows.length}}&nbsp;</span>
      </ng-template> -->
    </kendo-grid-column>
    <kendo-grid-column field="environments" title="Environment" [width]="120" class="cell">
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div title="{{dataItem.environments}}">{{dataItem.environments}}</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Support" [width]="80" class="cell">
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        @if (dataItem.favicon) {
          <img src="{{dataItem.favicon}}">
          }&nbsp;
          @if (dataItem.solution) {
            <a href="{{dataItem.solution.publisherid.supportingwebsiteurl}}" target="_blank" style="text-decoration: underline !important;">@if (dataItem.solution) {
              <span>{{dataItem.solution.publisherid.friendlyname}}</span>
            }</a>
          }
          <!-- <li *ngIf="group.solution">{{group.solution.publisherid.emailaddress}}</li>
          <li *ngIf="group.solution">{{group.solution.publisherid.address1_telephone1}}</li>                       -->
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Flows" [width]="25" class="cell">
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{dataItem.flows.length}}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="tRuns" title="Runs" [width]="25" class="cell">
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span style="display:inline">{{ dataItem.tRuns}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="tFails" title="Fails" [width]="25" class="cell">
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span style="display:inline;" [style.color]="dataItem.tFails > 0 ? 'red' : 'black'">{{dataItem.tFails}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="tEstimates" title="Estimate" [width]="25" class="cell">
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span style="display:inline" [style.color]="dataItem.tEstimates > 5000 ? 'red' : 'black'">{{ dataItem.tEstimates | number:'1.0-0' }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="tActions" title="Actions" [width]="25" class="cell">
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <span style="display:inline">{{ dataItem.tActions | number:'1.0-0' }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="modified" title="Last Modified" [width]="60" [minResizableWidth]="60" type="date" format="{0:y-MM-dd HH:mm}"
        filter="date" class="cell" [style]="{'min-width': '65px'}">
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <span title="{{dataItem.modified|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.modified|date:'y-MM-dd HH:mm'}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="lastRun" title="Last Run" [width]="60" [minResizableWidth]="60" type="date" format="{0:y-MM-dd HH:mm}"
        filter="date" class="cell" [style]="{'min-width': '65px'}">
        <ng-template kendoGridHeaderTemplate let-column>
          <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem>
          <span title="{{dataItem.lastRun|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.lastRun|date:'y-MM-dd HH:mm'}}</span>
        </ng-template>
      </kendo-grid-column>
      <ng-template kendoGridDetailTemplate let-group="dataItem">
        <div style="display:flex;">
          <div style="overflow-y: auto; flex-basis: 25%;">
            <h4>Environments</h4>
            @for (env of group.envs; track env) {
              <div title="{{env.name}} ({{env.properties.environmentType}})">{{env.properties.displayName}}</div>
            }
            <h4>Support</h4>
            <ul>
              @if (group.favicon) {
                <li><img src="{{group.favicon}}"></li>
              }
              @if (group.solution) {
                <li>{{group.solution.publisherid.friendlyname}}</li>
              }
              @if (group.solution) {
                <li>{{group.solution.publisherid.supportingwebsiteurl}}</li>
              }
              @if (group.solution) {
                <li>{{group.solution.publisherid.emailaddress}}</li>
              }
              @if (group.solution) {
                <li>{{group.solution.publisherid.address1_telephone1}}</li>
              }
            </ul>
            @if (group.solution) {
              <h4>Solution</h4>
            }
            @if (group.solution) {
              <ul>
                <li title="{{group.solution.solutionid}}">{{group.solution.friendlyname}} ({{group.solution.version}})</li>
              </ul>
            }
          </div>
          <div style="overflow-y: auto; flex-basis: 25%;">
            <h4>Owners</h4>
            <!-- <button (click)="loadMore(group)">^</button> -->
            <ul>
              @for (owner of group.owners; track owner) {
                <li>{{owner}}</li>
              }
            </ul>
            <h4>Connections ({{group.connections.length}})</h4>
            @for (connection of group.connections; track connection) {
              <div title="{{ connection.connectionName || connection | json}}">
                <img [src]='this.getSafeUrl(connection.iconUri)' style='width:20px; height:20px; vertical-align:middle;' />
                {{connection.displayName}}
              </div>
            }
            <h4>Classification</h4>
          </div>
          <div style="flex-basis: 50%;">
            @for (item of group.flows; track item) {
              <div>
                <app-success-line [item]="item"></app-success-line>
              </div>
            }
          </div>
          <!-- <kendo-sortable
          [kendoSortableBinding]=""
          [itemStyle] = "{'border': '0px', 'opacity':'1', 'cursor': 'move'}"
          [emptyItemStyle] = "{'height': '350px', 'border': '2px dashed black'}"
          [activeItemStyle] = "{'border': '2px dashed black', 'opacity':'0.7'}"
          zone="innerZone">
          <ng-template let-item="item">
          </ng-template>
        </kendo-sortable> -->
      </div>
    </ng-template>
  </kendo-grid>
  <grid-context-menu [for]="grid" [menuItems]="['Enable', 'Disable', 'Run Report...', 'Migrate...', 'Send Error to Support...', 'Trigger Flow...']" [admin]="true" (select)="onSelect($event)">
  </grid-context-menu>
}
@if (!this.ready) {
  <div class="k-i-loading"></div>
}

<kendo-pdf-export #pdf forcePageBreak=".page-break">

  <!-- <div *ngIf="this.doPdf"> -->
  @for (group of groups; track group) {
    <div title="{{group.name}} ({{group.environments}})">
      <h2>{{group.name}}</h2>
      <div>{{group.environments}}</div>
      @for (item of group.flows; track item) {
        <div>
          {{item.displayName}}, {{item.tags}}, Trigger: <span><img
          [src]='this.getSafeUrl(item.triggerIcon)' style='width:20px; height:20px; vertical-align:middle;' />
        {{item.trigger}} / {{item.triggerKind}}</span>, Actions: {{ item.actionsCount }}, State: {{item.flowState}}, Sharing: {{ item.sharingType}},
        Modified: <span title="{{item.modified|date:'y-MM-dd HH:mm:ss a' }}">{{item.modified|date:'y-MM-dd HH:mm'}}</span>,
        Fails: {{ item.runsFailCount }},
        Last Run: <span title="{{item.lastRun|date:'y-MM-dd HH:mm:ss a' }}">{{item.lastRun|date:'y-MM-dd HH:mm'}}</span>
        <!-- <app-success-line [item]="item"></app-success-line> -->
      </div>
    }
  </div>
}
<!-- </div> -->

</kendo-pdf-export>


</div>

